import moment from "moment";
import { useEffect, useRef, useState } from "react";
// TODO: Replace with backend endpoint
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { handleApiError, safeJsonParse } from "../../../utils/api";

export default function ExportNlpEvents() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isAdmin = localStorage.getItem('isAdmin');

    const tableRef = useRef(null);

    const [events, setEvents] = useState<any[]>([]);

    useEffect(() => {
        const requestOptionsPost = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/stats/usage-nlp', requestOptionsPost)
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then(data => {
                if (!data) return;
                setEvents(data);
            });
    }, []);

    return (
        <div>
                {/* TODO: Replace with backend endpoint for Excel export */}
                <button disabled>Export (Pendiente)</button>

                <table  ref={tableRef.current}>
                 <tbody>
                    <tr>
                        <th>{ t("Email") }</th>
                        <th>{ t("Group") }</th>
                        <th>{ t("Subgroup") }</th>
                        <th>{ t("Option") }</th>
                        <th>{ t("Timestamp") }</th>
                    </tr>
                    { events.map((e: any) => {
                        return <tr>
                            <td>{ e.user }</td>
                            <td>{ e.group }</td>
                            <td>{ e.subgroup }</td>
                            <td>{ e.option }</td>
                            <td>{ moment(e.start).format('YYYY-MM-DD hh:mm:ss') }</td>
                        </tr>;
                    })}
                  </tbody>
                </table>

            </div>);
}